import { Component, Input } from "@angular/core";
import { FormControl } from "@angular/forms";
import { FormItemModel } from "services/models/form-builder/form-item.model";

@Component({
  selector: "app-form-input-date",
  template: `
    <input
      type="date"
      class="form-control field-space"
      [required]="item.required"
      [formControl]="control"
      [readonly]="readonly"
    />
  `,
})
export class FormInputDateComponent {
  @Input() item!: FormItemModel;
  @Input() control!: FormControl;
  @Input() readonly: boolean = false;
}
